webpackJsonp([135537090715985],{

/***/ 1409:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Ryan Sobol","slug":"blog/author/ryan-sobol","twitter":"ryansobol","linkedIn":null,"website":"","biography":"Ryan is web developer, passionate about the craft of building Ruby and JavaScript apps. Sometimes he wants to give it all up and become a genius, playboy, billionaire philanthropist.","image":{"fields":{"description":"blog-author-ryan-sobol.jpg","file":{"url":"//images.ctfassets.net/k428n7s2pxlu/2NLo6cQ2uskQkAmI4uIyYU/2cca3e9de3da7839f46c5d2210266efb/blog-author-ryan-sobol.jpg"}}}}},"pathContext":{"slug":"blog/author/ryan-sobol"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-ryan-sobol-bbfdd7ba1ad4f8da886d.js